import { Select } from 'antd';
import type React from 'react';
import { type SelectOption } from '../SelectInput.tsx';

export function renderSelectOptions(
  group?: boolean,
  options?: SelectOption[] | null | undefined,
  renderOption?: (option: SelectOption) => React.ReactNode,
) {
  return group
    ? options?.map(option => (
        <Select.OptGroup label={option.label} key={option.key}>
          {option.options?.map(opt => (
            <Select.Option key={opt.value} {...opt}>
              {renderOption ? renderOption(opt) : opt.label}
            </Select.Option>
          ))}
        </Select.OptGroup>
      ))
    : options?.map(option => (
        <Select.Option key={option.value} {...option}>
          {renderOption ? renderOption(option) : option.label}
        </Select.Option>
      ));
}
